import { render, staticRenderFns } from "./StudentsRequiringAction.vue?vue&type=template&id=e410d1be&scoped=true&"
import script from "./StudentsRequiringAction.vue?vue&type=script&lang=js&"
export * from "./StudentsRequiringAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e410d1be",
  null
  
)

export default component.exports